import './vendor/flickity.pkgd.min.js';


import './main.js';